<script setup lang="ts">
import { storeToRefs } from "pinia";
import { Download, Loader2 } from "lucide-vue-next";
import { useResultsV2Store } from "@stores/survey/resultsV2/resultsV2";
import { usePrintDashboard } from "@/composables/usePrintDashboard";
import { Button } from "@/components/ui/button";

const { printing } = storeToRefs(useResultsV2Store());
const { printDashboard } = usePrintDashboard();
</script>

<template>
  <Button variant="ghost" :disabled="printing" @click="printDashboard">
    <Loader2 v-if="printing" class="mr-1.5 h-3.5 w-3.5 animate-spin" />
    <Download v-else class="mr-1.5 h-3.5 w-3.5" />
    Download
  </Button>
</template>
